export const burgerMenuReducerPath = 'burgerMenu';
